export const dp_font_weight_regular = 400;
export const dp_font_weight_medium = 500;
export const dp_font_weight_semibold = 600;
export const dp_font_weight_bold = 700;
